import React from "react";
import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";
import { getPOIPlace } from "utils/getPOIPlace";

/** Label/value rows; wraps to two columns on tablets. Empty values show "-". */
const InfoList = ({ title, items }) => (
  <Box component="section" sx={{ bgcolor: "background.paper", borderRadius: 2, px: 2, py: 1.5 }}>
    <Typography variant="h6" sx={{ fontSize: 16, fontWeight: 700, mb: 1 }}>{title}</Typography>
    <Box component="dl" sx={{
      m: 0, display: "grid", columnGap: 3, rowGap: 1,
      gridTemplateColumns: { xs: "minmax(0, 1fr)", sm: "repeat(2, minmax(0, 1fr))" },
    }}>
      {items.map(item => (
        <Box key={item.label} sx={{ display: "grid", gridTemplateColumns: "104px minmax(0, 1fr)", columnGap: 1 }}>
          <Typography component="dt" sx={{ fontSize: 14, color: "text.secondary" }}>{item.label}</Typography>
          <Typography component="dd" sx={{ m: 0, fontSize: 14, fontWeight: 500, overflowWrap: "anywhere" }}>
            {item.value || "-"}
          </Typography>
        </Box>
      ))}
    </Box>
  </Box>
)

/** Touch layout of the ข้อมูลชอร์ panel of DailyJobDialogV3 (read only), shown on the ข้อมูลใบงาน tab. */
export const ShoreInfoCompact = React.memo(({ joData }) => {
  const shore = joData.Shore
  return (
    <InfoList title="ข้อมูลชอร์" items={[
      { label: "วันที่จ่ายชอร์", value: shore?.ShorDte && dayjs(shore.ShorDte).format("DD/MM/YYYY") },
      { label: "เลขที่ใบเสร็จ", value: shore?.RcptNo },
      { label: "ท่าคืน", value: shore && getPOIPlace(shore, "RTN") },
      { label: "ชื่อเรือ", value: shore?.Vssl && `${shore.Vssl} V.${shore.Voy || ""}` },
    ]} />
  )
})

/** Touch layout of the ข้อมูลใบแจ้งลาก panel of DailyJobDialogV3 (read only). */
const ShipmentInfoCompact = ({ joData, msData }) => {
  const refNm = msData.serverData.RefColumnName?.shipment || {}
  return (
    <InfoList title="ข้อมูลใบแจ้งลาก" items={[
      { label: "ลูกค้า", value: joData.CusSNm },
      { label: "งาน", value: joData.JobSNm },
      { label: "ประเภทงาน", value: msData.ShpmTypObj[joData.ShpmTypId] },
      { label: "จำนวนตู้", value: joData.NumJob },
      { label: "JobNo", value: joData.JobNo },
      { label: "Booking", value: joData.Bkg },
      { label: "Agent", value: joData.Agnt },
      { label: "Vessel", value: joData.Vssl ? `${joData.Vssl} V.${joData.Voy || ""}` : "" },
      { label: refNm.Ref1 || "อ้างอิง1", value: joData.ShRef1 },
      { label: refNm.Ref2 || "อ้างอิง2", value: joData.ShRef2 },
      { label: "หมายเหตุ", value: joData.ShRmk },
    ]} />
  )
}

export default React.memo(ShipmentInfoCompact)
